<template>
  <header
    class="header fixed up priority-4 full-width-navigation full-width-navigation"
    :class="{
      'open-mobile-progress': openMobile,
    }"
  >
    <div class="mobile-overlay" @click="openMobile = false"></div>

    <div class="absolute wrapper up background-background priority-2"></div>

    <a v-if="$route.meta.step === 1 || !model.isMobile" class="c-pointer priority-3" href="https://www.union.sk"
       target="_blank">
      <i class="icon icon--union priority-2"></i>
    </a>
    <i
      class="icon icon--arrow-left-mobile priority-2"
      v-if="$route.meta.step !== 1 && model.isMobile"
      @click="goBack"
    ></i>

    <div class="progress-bar priority-2">
      <div
        class="full-height flex align-items-center"
        v-for="(link, index) in links"
        :key="index + 1"
      >
        <div
          class="link"
          v-bind:class="{actual: $route.meta.step === link.meta.step, active: model.lastStep >= link.meta.step}"
        >
          <i class="icon icon--header-checked"></i>
          <a @click.prevent="goToStep(link.meta.step)">{{ link.meta.label }}</a>
        </div>
        <span v-if="link.meta.step !== links.length"></span>
      </div>
    </div>

    <div class="mobile-progress-bar priority-1">
      <div class="control-panel">
        <span>Osobné údaje</span>
        <div
          class="close-hamburger"
          @click="openMobile = false"
        >
          <span></span><span></span>
        </div>
      </div>

      <div class="content">
        <ul type="none">
          <li
            v-for="(link, index) in links"
            :key="index + 1"
            :class="{active: model.lastStep >= link.meta.step, actual: $route.name === link.name}"
            @click.prevent="goToStep(link.meta.step)"
          >
            <div class="mobile-progress-icon">
              <i class="icon icon--header-checked"></i>
              <span class="mobile-progress-line"></span>
            </div>
            <span>{{ link.meta.label }}</span>
          </li>
        </ul>

        <div class="f-column mb-children-2 mobile-footer">
          <p><a target="_blank" href="https://www.union.sk/union-o-poistovni">Informácie o poisťovateľovi</a></p>
          <p class="mb-4">
            <a target="_blank"
               href='
               https://www.union.sk/wp-content/uploads/2021/03/Zakladne-informacie-o-ochrane-osobnych-udajov_potencialni-klienti-klienti-alebo-osoba-opravnena-na-prijatie-poistneho-plnenia-1.pdf'
            >Ochrana osobných údajov</a>
          </p>
          <p class="font-small">© 2021 Union poisťovňa, a. s.</p>
        </div>
      </div>
    </div>

    <div class="f-center">
      <button
        id="save-later"
        class="button-border-gray still-small"
        v-if="$route.meta.step > 2"
        v-scroll-to-error
        @click="saveForLater"
      >Uložiť na neskôr
      </button>

      <div
        class="hamburger ml-2 priority-3"
        @click="openMobile = !openMobile"
      >
        <span></span><span></span><span></span>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Navigation',
  data() {
    return {
      openMobile: false,
    };
  },
  computed: {
    links() {
      return this.$router.options.routes
        .filter((route) => route.meta && route.meta.label);
    },
    ...mapGetters({ model: 'getModel', errors: 'getErrors' }),
  },
  methods: {
    ...mapActions({
      save: 'saveForLater',
    }),
    async saveForLater() {
      await this.$store.commit('SET_ATTEMPTED', true);
      try {
        document.querySelectorAll('.upload-container.has-error').forEach((el) => { el.classList.remove('has-error'); });
        document.querySelectorAll('#FE013.error').forEach((el) => { el.style.display = 'none'; });
        const isSaved = await this.save();
        if (isSaved) {
          this.$router.goToStep(4);
        }
      } catch (e) {
        this.$router.goToStep(4);
        this.$store.commit('SET_LOADING', false);
      }
    },
    goToStep(step) {
      if (step === 1) this.$router.goToStep(step);
      else {
        this.$store.commit('SET_STEP', step - 1);
        this.$nextTick(() => {
          if (this.errors.length === 0 && this.model.lastStep >= step) {
            this.$router.maxStep = step;
            this.$router.goToStep(step);
          } else this.$store.commit('SET_STEP', this.$route.meta.step);
        });
      }
    },
    goBack() {
      const step = parseInt(this.$route.name.replace('Step', ''), 10);
      this.$router.goToStep(step - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
#save-later {
  font-size: 13px;
  z-index: 20000;
  min-height: unset;
  padding: 14px 26px;
  @media (max-width: 1024px) {
    padding: 8px 10px;
  }
}
</style>
